import { render } from "./HeroiconsSolidTag.vue?vue&type=template&id=19b7f657"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTag.vue"]])

export default __exports__